import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

// authentication check (e.g., check token in localStorage)
const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; // in seconds
    return decoded.exp > currentTime;
  } catch (error) {
    // Token is invalid or couldn't be decoded
    return false;
  }
};

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  // Standard employee routes
  const employeeAllowedPaths = [
    '/mydashboard', '/requestemployee', '/leave-request', '/requestsdoc', '/it',
    '/notifications', '/hr-staff', '/policies', '/about', '/leaves', '/absence',
    '/leave-rules', '/profile', '/policies/view', '/policy-viewer', '/year-calendar',
    '/adhan-times', '/timesheet',
  ];

  // Additional routes accessible to Project Managers (EMPLOYEE with Project Manager position)
  const projectManagerAllowedPaths = ['/my-team'];

  const userRole = localStorage.getItem('userRole');
  const userPosition = localStorage.getItem('userPosition');
  const isProjectManager = userRole === 'EMPLOYEE' && userPosition === 'Project Manager';

  if (!isAuthenticated()) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ notification: 'You are not logged in. Please log in to continue.' }}
      />
    );
  }

  if (userRole === 'EMPLOYEE' || userRole === 'DEV') {
    const pathname = location.pathname;

    // Allow team-profile dynamic route for PMs and DEV
    const isTeamProfileRoute = pathname.startsWith('/team-profile/');

    const isAllowed =
      userRole === 'DEV' || // DEV has full access to these paths
      employeeAllowedPaths.includes(pathname) ||
      (isProjectManager && (projectManagerAllowedPaths.includes(pathname) || isTeamProfileRoute));

    if (!isAllowed) {
      return <Navigate to={isProjectManager || userRole === 'DEV' ? '/my-team' : '/mydashboard'} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
